module.exports = __webpack_public_path__ + "img/key_white_24dp.7fc1d552.png";